(function () {
  function initGaleria(section) {
    var track = section.querySelector('[data-mc-galcomp-track]');
    var dots = section.querySelectorAll('[data-mc-galcomp-dot]');
    if (!track || !dots.length) return;

    var items = section.querySelectorAll('[data-mc-galcomp-item]');
    if (!items.length) return;

    function setActive(idx) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    // IntersectionObserver: detecta cuál item está más visible en el viewport
    // del track (no del viewport global). Solo aplica en mobile (cuando hay scroll).
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          var idx = Array.prototype.indexOf.call(items, entry.target);
          if (idx >= 0) setActive(idx);
        }
      });
    }, {
      root: track,
      threshold: [0.5, 0.75],
    });

    items.forEach(function (item) { observer.observe(item); });
  }

  function initAll() {
    document.querySelectorAll('[data-mc-galcomp]').forEach(initGaleria);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
